import { HTTPClient } from "@/utils/request.catalog";

export default {
  get: ({ payload }) =>
    HTTPClient.post("/api/Catalogo/DisponibilidadeMovel", payload),

  // Não exluir essa linha, url do catalogo em produção
  // getFixa: () => HTTPClient.get("/fibra/catalogo_vivo_fixa-min.json"),

  // novo catalogo para testes
  getFixa: () => HTTPClient.get("/fibra/New catalogo fixa.json"),
};
